export interface OpeningStockLineUi {
  /** UI-only stable key */
  key: string
  id: number
  itemId: number
  batchItemId: number
  wareHouseId: number
  shelfId: string
  availableQuantity: number
  damagedStock: number
  expiredStock: number
  holdStock: number
  isDeleted: boolean
}

export function newOpeningLineUi(seed?: Partial<OpeningStockLineUi>): OpeningStockLineUi {
  return {
    key: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    id: 0,
    itemId: 0,
    batchItemId: 0,
    wareHouseId: 0,
    shelfId: '',
    availableQuantity: 0,
    damagedStock: 0,
    expiredStock: 0,
    holdStock: 0,
    isDeleted: false,
    ...seed,
  }
}
